import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, toHandlers as _toHandlers, mergeProps as _mergeProps, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "call-panel-wrapper" }
const _hoisted_2 = { class: "modal-body call-panel-body" }
const _hoisted_3 = { class: "dialer-container bg-white" }
const _hoisted_4 = {
  key: 0,
  style: {"font-size":"0.8rem"}
}
const _hoisted_5 = {
  key: 1,
  style: {"font-size":"0.8rem"}
}
const _hoisted_6 = { class: "input-group mb-3 dialer-input" }
const _hoisted_7 = { class: "input-group-text bg-white border-0" }
const _hoisted_8 = { style: {"flex":"1"} }
const _hoisted_9 = { class: "input-group-text bg-white border-0" }
const _hoisted_10 = {
  key: 2,
  class: "search-dropdown"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "contact-name-text" }
const _hoisted_13 = {
  key: 0,
  class: "contact-company"
}
const _hoisted_14 = {
  key: 0,
  class: "contact-phones"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "phone-type-label" }
const _hoisted_17 = { class: "phone-number-text" }
const _hoisted_18 = {
  key: 1,
  class: "contact-no-phone"
}
const _hoisted_19 = {
  class: "loading",
  style: {"position":"relative","bottom":"17px"}
}
const _hoisted_20 = { class: "loading-bar" }
const _hoisted_21 = { class: "d-flex flex-wrap justify-content-center" }
const _hoisted_22 = { class: "row phone-numbers-header" }
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = {
  class: "phone-numbers-actions",
  style: {"display":"flex","align-items":"center","gap":"12px","justify-content":"flex-end","flex-wrap":"nowrap"}
}
const _hoisted_25 = {
  class: "row",
  style: {"margin-top":"8px","margin-bottom":"8px","margin-left":"-12px","margin-right":"-12px"}
}
const _hoisted_26 = {
  class: "col-12",
  style: {"padding-left":"12px","padding-right":"12px"}
}
const _hoisted_27 = { class: "phone-list-section" }
const _hoisted_28 = {
  class: "row justify-content-between",
  style: {"margin-top":"18px"}
}
const _hoisted_29 = { class: "col-6" }
const _hoisted_30 = {
  class: "row",
  style: {"margin-top":"8px","padding-left":"15px","padding-right":"15px"}
}
const _hoisted_31 = { style: {"width":"100%"} }
const _hoisted_32 = { class: "calling-from-header" }
const _hoisted_33 = { class: "calling-from-note" }
const _hoisted_34 = {
  key: 3,
  class: "row",
  style: {"margin-top":"0px","padding-left":"15px","padding-right":"15px"}
}
const _hoisted_35 = { style: {"width":"100%"} }
const _hoisted_36 = { class: "no-phone-number-banner" }
const _hoisted_37 = {
  key: 4,
  class: "row",
  style: {"margin-top":"0px","padding-left":"15px","padding-right":"15px","overflow":"visible"}
}
const _hoisted_38 = { style: {"width":"100%","display":"flex","gap":"8px","position":"relative","align-items":"center"} }
const _hoisted_39 = { style: {"flex":"1"} }
const _hoisted_40 = { style: {"position":"relative"} }
const _hoisted_41 = {
  key: 0,
  class: "buy-phone-card"
}
const _hoisted_42 = { class: "card-header" }
const _hoisted_43 = { class: "header-content" }
const _hoisted_44 = { class: "icon" }
const _hoisted_45 = { class: "card-body" }
const _hoisted_46 = {
  class: "row",
  style: {"margin-top":"12px","padding-left":"15px","padding-right":"15px"}
}
const _hoisted_47 = { style: {"width":"100%"} }
const _hoisted_48 = {
  class: "disposition-readonly",
  title: "Update disposition in Call History"
}
const _hoisted_49 = { class: "disposition-readonly__value" }
const _hoisted_50 = ["disabled"]

import { ref, computed, watch, onMounted, onBeforeUnmount, markRaw } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Icon } from "@iconify/vue";
import parsePhoneNumberFromString, { AsYouType } from "libphonenumber-js";
import debounce from "lodash/debounce";

import DeletePhoneNumberModal from "@/components/contacts/DeletePhoneNumberModal.vue";
import CallInfoRow, { type CallStatus } from "@/components/contacts/CallInfoRow.vue";
import AddPhoneNumberModal from "@/components/contacts/AddPhoneNumberModal.vue";
import EditPhoneNumberModal from "@/components/contacts/EditPhoneNumberModal.vue";
import LastInteractionModal from "@/components/bucket/LastInteractionModal.vue";

import { Button, Select } from "@/components/ui";
import OutreachCueCards from "@/components/bucket/ai/OutreachCueCards.vue";
import DraggableCallScript from "@/components/bucket/ai/DraggableCallScript.vue";
import CallSessionModal from "@/components/call/CallSessionModal.vue";
import Twilio from "@/services/twilio/twilio";
import { REGISTER_ACTIVITY_LOG } from "@/store/action-types";
import { TaskType } from "@/utils/enums";
import { formatLocation } from "@/utils/const";
import { disableBeforeUnload } from "@/utils/unloadGuard";
import filters from "@/utils/filters";
import { useContactData } from "@/composables/contacts/useContactData";
import { useDeleteContactPhoneNumber } from "@/composables/contacts";
import { getSocket } from "@/utils/socket";
import { useBillingStatus } from "@/composables/billing/useBillingStatus";
import { useToast } from "@/composables/ui/useToast";
import { useCallDispositions, useRegisterCallLog, usePhoneNumbers } from "@/composables/calls";
import { PhoneNumberDto } from "@/dtos/PhoneNumber.dto";
import { useIncomingCall } from "@/composables/calls/useIncomingCall";
import { usePostCallLock } from "@/composables/calls/usePostCallLock";
import { useAIAssistant } from "@/composables/calls/useAIAssistant";

// --- Props & Emits ---

interface Props {
  selectedBucket: any;
  contact?: any;
  isActive?: boolean;
  incomingCallData?: any;
  icps?: any[];
  icpLoading?: boolean;
  pendingCueCardContent?: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CallInteractionPanel',
  props: {
    selectedBucket: {},
    contact: { default: null },
    isActive: { type: Boolean, default: true },
    incomingCallData: { default: null },
    icps: { default: () => [] },
    icpLoading: { type: Boolean, default: false },
    pendingCueCardContent: { default: null }
  },
  emits: ["refresh-buckets", "save-and-log-call", "close-modal", "show-edit-contact-modal", "answer-incoming-call", "decline-incoming-call", "open-ai-personalization", "switch-channel", "content-applied"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// --- Global Utilities & Composables ---

const store = useStore();
const router = useRouter();
const $toast = useToast();
const { showUsageBasedFeaturesModalOnce } = useBillingStatus();
const { setOutboundCallSid, clearOutboundCallSid } = useIncomingCall();
const {
  startPostCallLock,
  onDispositionSaved: releasePostCallLock,
  clearPostCallLock,
  pendingCallSid,
  isDispositionPending,
} = usePostCallLock();
const {
  prepareContext,
  enableAssistant,
  disableAssistant,
  latestSuggestion,
  currentStreamingText,
  isThinking,
  isStreaming,
  hasSuggestions,
  suggestions,
} = useAIAssistant();

// --- AI Choice State ---
const showAIPrompt = ref(false);
const pendingCallNumber = ref<string | null>(null);
const pendingCallWithAI = ref(false);
// ICP picked on the pre-call prompt (AI or manual) — sent with the call so
// the AI call summary uses it.
const pendingCallIcpId = ref<string | null>(null);
const isPreparingAIContext = ref(false);

const account = computed(() => store.getters.account.data);
const contact = computed(() => props.contact || store.getters.contact.data);
const contacts = computed(() => store.getters.contacts.data);
const contactsIsLoading = computed(() => store.getters.contacts.isLoading);
const callHistoryContactId = computed(
  () => contact.value?.id || props.selectedBucket?.contactId || ""
);

// --- TanStack Query ---

// Call Dispositions
const callDispositionsParams = computed(() => {
  if (!account.value?.organizationId) return null;
  return { organizationId: account.value.organizationId };
});
const { data: callDispositionsData } = useCallDispositions(callDispositionsParams);
const callDispositions = computed(() => callDispositionsData.value || []);

const latestCallDispositionName = computed(() => {
  const c = contact.value || props.selectedBucket?.contact;
  if (!c?.callLogs || !Array.isArray(c.callLogs) || c.callLogs.length === 0) return null;
  const sorted = [...c.callLogs]
    .filter((log: any) => log)
    .sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  const latest = sorted[0];
  if (latest?.callDisposition?.name) return latest.callDisposition.name;
  if (latest?.callDispositionId && callDispositions.value.length > 0) {
    const match = callDispositions.value.find((d: any) => d.id === latest.callDispositionId);
    return match?.name || null;
  }
  return null;
});

// Phone Numbers
const phoneNumbersParams = computed(() => {
  if (!account.value?.organizationId) return null;
  return { organizationId: account.value.organizationId };
});
const { data: phoneNumbersData } = usePhoneNumbers(phoneNumbersParams);
const phoneNumbers = computed(() => {
  const raw = phoneNumbersData.value?.data || [];
  return raw.map((number: PhoneNumberDto) => {
    if (!number.countryCode && number.number) {
      try {
        const phoneNumber = parsePhoneNumberFromString(number.number);
        if (phoneNumber && phoneNumber.isValid()) {
          return {
            ...number,
            countryCode: phoneNumber.country || number.countryCode,
            description: formatHealthTooltip(number),
          };
        }
      } catch (error) {
        console.warn("Failed to parse phone number:", number.number, error);
      }
    }
    return { ...number, description: formatHealthTooltip(number) };
  });
});

// Mutations
const { mutateAsync: registerCallLog } = useRegisterCallLog();
const { deleteContactPhoneNumber: deletePhoneMutation } = useDeleteContactPhoneNumber();

// Contact data bridge (Vuex)
const { getContact: getContactFn, getContacts: getContactsFn } = useContactData(store);
function getContact() {
  return getContactFn(props.selectedBucket, account.value, emit as any);
}
function getContacts() {
  if (isPhoneInput.value) {
    return getContactsFn(account.value, "", stripFormatting(searchTerm.value));
  }
  return getContactsFn(account.value, searchTerm.value);
}

// --- Local Reactive State ---

// Call state
const currentCall = ref<any>(null);
const currentCallSid = ref<string | null>(null);
const parentCallSid = ref<string | null>(null);
const status = ref<CallStatus>("ready");
const to = ref("");
const isMuted = ref(false);
const saveRecording = ref(true);
const selectedMicId = ref("");
const selectedSpeakerId = ref("");
const isTransferringCall = ref(false);
const callDuration = ref(0);
const callTimer = ref<ReturnType<typeof setInterval> | null>(null);

// UI state
const showAddPhoneNumberModal = ref(false);
const showEditPhoneNumberModal = ref(false);
const showBuyPhoneNumberModal = ref(false);
const showDeleteConfirmationModal = ref(false);
const showCallScriptPanel = ref(false);
const showLastInteractionModal = ref(false);
const showDialerDropdown = ref(false);
const showIVRDropdown = ref(false);
const showMicrophoneDropdown = ref(false);
const addModalAnchorRect = ref<DOMRect | null>(null);
const editModalAnchorRect = ref<DOMRect | null>(null);

// Selection state
const selectedNumber = ref<string | null>(null);
const selectedNumberObj = ref<PhoneNumberDto | null>(null);
const selectedContactNumber = ref<any>(null);

// Call logging state
const mustLogAfterCall = ref(false);
const hasBaseCallLogCreated = ref(false);
const hasCallBeenLogged = ref(false);

// Misc
const microphones = ref<any[]>([]);
const speakers = ref<any[]>([]);
const searchTerm = ref("");
const ivrInputValue = ref("");
const showSearchDropdown = ref(true);
const pressTimer = ref<ReturnType<typeof setTimeout> | null>(null);
const pressedKey = ref<string | null>(null);
const isInitializingTwilio = ref(false);
const numberDialingInfo = ref<any[]>([]);
const callScriptSteps = ref<any[]>([]);
const socket = ref<any>(null);

// Edit bucket (stays in Vuex)
const editBucketObj = ref({
  id: null as any,
  taskType: null as any,
  followUpDate: null as any,
  bucketOptionId: null as any,
});

// Template refs
const dialerDropdown = ref<HTMLElement | null>(null);
const ivrPopover = ref<HTMLElement | null>(null);

// Audio context for DTMF tones
const audioContext = ref<AudioContext | null>(null);

// --- Computed Properties ---

const hasPhoneNumbers = computed(() => phoneNumbers.value && phoneNumbers.value.length > 0);

const enableTranscription = computed(() => account.value?.enableTranscription !== false);

const enableAISummary = computed(
  () => enableTranscription.value && account.value?.enableAISummary !== false
);

const formattedCallTimer = computed(() => {
  const hours = String(Math.floor(callDuration.value / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((callDuration.value % 3600) / 60)).padStart(2, "0");
  const seconds = String(callDuration.value % 60).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
});

const formattedIncomingCallTimer = computed(() => {
  if (!props.incomingCallData?.callDuration) return "00:00:00";
  const duration = props.incomingCallData.callDuration;
  const hours = String(Math.floor(duration / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((duration % 3600) / 60)).padStart(2, "0");
  const seconds = String(duration % 60).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
});

const icpOptions = computed(() => {
  const options: any[] = [
    {
      value: "",
      label: "Select ICP for Call Script",
    },
  ];
  (props.icps || []).forEach((icp: any) => {
    options.push({
      value: icp.id,
      label: icp.isDefault ? `${icp.name} (Default)` : icp.name,
    });
  });
  return options;
});

const activeCallStates = computed(() => ["connecting", "ringing", "in-call", "reconnecting"]);

const allContactNumbers = computed(() => {
  const numbers: any[] = [];
  const c = contact.value || props.selectedBucket?.contact;

  if (!props.selectedBucket || !c) {
    return numbers;
  }

  const getCallLogDataForNumber = (phoneNumber: string) => {
    if (!c?.callLogs || !Array.isArray(c.callLogs)) {
      return {
        callSid: null,
        callType: null,
        isValidLead: null,
        ivrNumbers: null,
        gateKeeperName: null,
      };
    }

    try {
      const callLog = c.callLogs
        .filter((log: any) => log && log.to === phoneNumber)
        .sort(
          (a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        )[0];

      if (!callLog)
        return {
          callSid: null,
          callType: null,
          isValidLead: null,
          ivrNumbers: null,
          gateKeeperName: null,
        };

      return {
        callSid: callLog.callSid || null,
        callType: callLog.callType || null,
        isValidLead: callLog.isValidLead,
        ivrNumbers: callLog.ivrNumbers || null,
        gateKeeperName: callLog.gateKeeperName || null,
      };
    } catch (error) {
      console.error("Error getting call log data:", error);
      return {
        callSid: null,
        callType: null,
        isValidLead: null,
        ivrNumbers: null,
        gateKeeperName: null,
      };
    }
  };

  if (c?.phones && Array.isArray(c.phones) && c.phones.length > 0) {
    c.phones.forEach((p: any) => {
      if (!p || !p.number || typeof p.number !== "string" || p.number.trim().length === 0) return;
      const callLogData = getCallLogDataForNumber(p.number);
      const uiLabel =
        p.type === "DIRECT"
          ? "Direct"
          : p.type === "MOBILE"
            ? "Mobile"
            : p.type === "WORK"
              ? "Work"
              : p.type === "HOME"
                ? "Home"
                : "Other";
      const uiCallType =
        p.routeType === "DIRECT"
          ? "Direct"
          : p.routeType === "MOBILE"
            ? "Mobile"
            : p.routeType === "IVR"
              ? "IVR"
              : p.routeType === "GATEKEEPER"
                ? "Gate Keeper"
                : uiLabel;
      const ivrNumbers =
        p.ivrExtension && p.ivrExtension.length === 3
          ? p.ivrExtension.split("")
          : callLogData.ivrNumbers;
      numbers.push({
        number: p.number,
        type: uiLabel,
        typeEditable: true,
        callSid: callLogData.callSid,
        callType: uiCallType,
        isValidLead:
          p.isValid === true
            ? true
            : p.isValid === false
              ? false
              : p.isValid === null
                ? null
                : callLogData.isValidLead,
        ivrNumbers,
        gateKeeperName: p.gatekeeperName || callLogData.gateKeeperName,
      });
    });
  }

  const contactObj = c || {};
  if (typeof contactObj.mobileNumber === "string" && contactObj.mobileNumber.trim()) {
    const data = getCallLogDataForNumber(contactObj.mobileNumber);
    numbers.push({
      number: contactObj.mobileNumber,
      type: "Mobile",
      callSid: data.callSid,
      callType: "Mobile",
      isValidLead: data.isValidLead,
      ivrNumbers: data.ivrNumbers,
      gateKeeperName: data.gateKeeperName,
    });
  }
  if (typeof contactObj.directNumber === "string" && contactObj.directNumber.trim()) {
    const data = getCallLogDataForNumber(contactObj.directNumber);
    numbers.push({
      number: contactObj.directNumber,
      type: "Direct",
      callSid: data.callSid,
      callType: "Direct",
      isValidLead: data.isValidLead,
      ivrNumbers: data.ivrNumbers,
      gateKeeperName: data.gateKeeperName,
    });
  }
  if (Array.isArray(contactObj.additionalPhoneNumbers)) {
    contactObj.additionalPhoneNumbers
      .filter((n: any) => typeof n === "string" && n.trim())
      .forEach((n: string) => {
        const data = getCallLogDataForNumber(n);
        numbers.push({
          number: n,
          type: "Other",
          callSid: data.callSid,
          callType: "Mobile",
          isValidLead: data.isValidLead,
          ivrNumbers: data.ivrNumbers,
          gateKeeperName: data.gateKeeperName,
        });
      });
  }

  if (Array.isArray(numberDialingInfo.value)) {
    numberDialingInfo.value
      .filter((n: any) => n && typeof n.phoneNumber === "string" && n.phoneNumber.trim())
      .forEach((n: any) => {
        const data = getCallLogDataForNumber(n.phoneNumber);
        const callType =
          n.routeType === "DIRECT"
            ? "Direct"
            : n.routeType === "MOBILE"
              ? "Mobile"
              : n.routeType === "IVR"
                ? "IVR"
                : n.routeType === "GATEKEEPER"
                  ? "Gate Keeper"
                  : "Mobile";
        numbers.push({
          number: n.phoneNumber,
          type: callType,
          callSid: data.callSid,
          callType,
          isValidLead: typeof n.isValid === "boolean" ? n.isValid : data.isValidLead,
          ivrNumbers: Array.isArray(n.ivrNumbers) ? n.ivrNumbers : data.ivrNumbers,
          gateKeeperName: n.gateKeeperName || data.gateKeeperName,
        });
      });
  }
  return numbers;
});

const validContactNumbers = computed(() =>
  allContactNumbers.value.filter(
    (phoneObj: any) =>
      phoneObj &&
      phoneObj.number &&
      typeof phoneObj.number === "string" &&
      phoneObj.number.trim().length > 0
  )
);

// --- DTMF Tone Helper ---

const DTMF_FREQS: Record<string, [number, number]> = {
  "1": [697, 1209],
  "2": [697, 1336],
  "3": [697, 1477],
  "4": [770, 1209],
  "5": [770, 1336],
  "6": [770, 1477],
  "7": [852, 1209],
  "8": [852, 1336],
  "9": [852, 1477],
  "*": [941, 1209],
  "0": [941, 1336],
  "#": [941, 1477],
  "+": [941, 1336],
};

function playDTMF(key: string) {
  const freqs = DTMF_FREQS[key];
  if (!freqs) return;
  try {
    if (!audioContext.value) {
      audioContext.value = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
    const ctx = audioContext.value;
    const gain = ctx.createGain();
    gain.gain.value = 0.1;
    gain.connect(ctx.destination);
    const now = ctx.currentTime;
    freqs.forEach((freq) => {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = freq;
      osc.connect(gain);
      osc.start(now);
      osc.stop(now + 0.1);
    });
  } catch (_) {}
}

// --- Phone Input Helpers ---

const isPhoneInput = computed(() => {
  if (!searchTerm.value) return false;
  return /^[+\d]/.test(searchTerm.value) && !/[a-zA-Z]/.test(searchTerm.value);
});

function stripFormatting(str: string) {
  return (str || "").replace(/[\s()\-]/g, "");
}

function formatDisplayNumber(number: string) {
  if (!number) return "";
  try {
    return new AsYouType().input(number);
  } catch {
    return number;
  }
}

// --- Dial Pad Helpers ---

function appendToSearchTerm(char: string) {
  const raw = stripFormatting(searchTerm.value) + char;
  if (isPhoneInput.value || /^[+\d]/.test(raw)) {
    searchTerm.value = new AsYouType().input(raw);
  } else {
    searchTerm.value += char;
  }
  playDTMF(char);
  showSearchDropdown.value = false;
}

function appendToIVRInputValue(char: string) {
  ivrInputValue.value += char;
  playDTMF(char);
  if (activeCallStates.value.includes(status.value)) {
    try {
      Twilio.sendDigits(char);
    } catch (_) {}
  }
}

function handleIVRBackspace() {
  ivrInputValue.value = ivrInputValue.value.slice(0, -1);
}

const capitalize = (value: string) => filters.capitalize(value);
const formatPhoneNumber = (value: string) => filters.formatPhoneNumber(value);

function handleDialerBackspace() {
  const raw = stripFormatting(searchTerm.value);
  if (!raw) {
    searchTerm.value = "";
    return;
  }
  const trimmed = raw.slice(0, -1);
  searchTerm.value = trimmed ? new AsYouType().input(trimmed) : "";
}

function onKeyDown(key: string) {
  if (key !== "0") {
    appendToSearchTerm(key);
    return;
  }
  pressedKey.value = key;
  pressTimer.value = setTimeout(() => {
    appendToSearchTerm("+");
    pressedKey.value = null;
  }, 600);
}

function onKeyUp(key: string) {
  if (pressedKey.value === "0" && pressTimer.value) {
    clearTimeout(pressTimer.value);
    appendToSearchTerm("0");
  }
  pressTimer.value = null;
  pressedKey.value = null;
}

function onKeyDownIVR(key: string) {
  if (key !== "0") {
    appendToIVRInputValue(key);
    return;
  }
  pressedKey.value = key;
  pressTimer.value = setTimeout(() => {
    appendToIVRInputValue("+");
    pressedKey.value = null;
  }, 600);
}

function onKeyUpIVR(key: string) {
  if (pressedKey.value === "0" && pressTimer.value) {
    clearTimeout(pressTimer.value);
    appendToIVRInputValue("0");
  }
  pressTimer.value = null;
  pressedKey.value = null;
}

// Dial pad button arrays (non-reactive constants)
const dialPadButtons = [
  { value: "1", specialClass: "", events: { click: () => appendToSearchTerm("1") } },
  { value: "2", specialClass: "", events: { click: () => appendToSearchTerm("2") } },
  { value: "3", specialClass: "", events: { click: () => appendToSearchTerm("3") } },
  { value: "4", specialClass: "", events: { click: () => appendToSearchTerm("4") } },
  { value: "5", specialClass: "", events: { click: () => appendToSearchTerm("5") } },
  { value: "6", specialClass: "", events: { click: () => appendToSearchTerm("6") } },
  { value: "7", specialClass: "", events: { click: () => appendToSearchTerm("7") } },
  { value: "8", specialClass: "", events: { click: () => appendToSearchTerm("8") } },
  { value: "9", specialClass: "", events: { click: () => appendToSearchTerm("9") } },
  { value: "*", specialClass: "", events: { click: () => appendToSearchTerm("*") } },
  {
    value: "0",
    specialClass: "",
    events: {
      mousedown: (e: Event) => {
        e.preventDefault();
        onKeyDown("0");
      },
      touchstart: (e: Event) => {
        e.preventDefault();
        onKeyDown("0");
      },
      mouseup: (e: Event) => {
        e.preventDefault();
        onKeyUp("0");
      },
      touchend: (e: Event) => {
        e.preventDefault();
        onKeyUp("0");
      },
    },
  },
  { value: "#", specialClass: "", events: { click: () => appendToSearchTerm("#") } },
];

const ivrDialPadButtons = [
  { value: "1", specialClass: "", events: { click: () => appendToIVRInputValue("1") } },
  { value: "2", specialClass: "", events: { click: () => appendToIVRInputValue("2") } },
  { value: "3", specialClass: "", events: { click: () => appendToIVRInputValue("3") } },
  { value: "4", specialClass: "", events: { click: () => appendToIVRInputValue("4") } },
  { value: "5", specialClass: "", events: { click: () => appendToIVRInputValue("5") } },
  { value: "6", specialClass: "", events: { click: () => appendToIVRInputValue("6") } },
  { value: "7", specialClass: "", events: { click: () => appendToIVRInputValue("7") } },
  { value: "8", specialClass: "", events: { click: () => appendToIVRInputValue("8") } },
  { value: "9", specialClass: "", events: { click: () => appendToIVRInputValue("9") } },
  { value: "*", specialClass: "", events: { click: () => appendToIVRInputValue("*") } },
  {
    value: "0",
    specialClass: "",
    events: {
      mousedown: (e: Event) => {
        e.preventDefault();
        onKeyDownIVR("0");
      },
      touchstart: (e: Event) => {
        e.preventDefault();
        onKeyDownIVR("0");
      },
      mouseup: (e: Event) => {
        e.preventDefault();
        onKeyUpIVR("0");
      },
      touchend: (e: Event) => {
        e.preventDefault();
        onKeyUpIVR("0");
      },
    },
  },
  { value: "#", specialClass: "", events: { click: () => appendToIVRInputValue("#") } },
];

// --- Methods ---

async function handleAnswerIncomingCall() {
  try {
    const TwilioModule = (await import("@/services/twilio/twilio")).default;
    const connection = TwilioModule.getActiveConnection();
    if (connection) {
      await TwilioModule.answerIncomingCall();
      emit("answer-incoming-call");
    }
  } catch (error) {
    console.error("[CallInteractionPanel] Failed to answer call:", error);
    $toast.error("Failed to answer call");
  }
}

async function handleDeclineIncomingCall() {
  try {
    const TwilioModule = (await import("@/services/twilio/twilio")).default;
    await TwilioModule.rejectIncomingCall();
    emit("decline-incoming-call");
  } catch (error) {
    console.error("[CallInteractionPanel] Failed to decline call:", error);
  }
}

async function handleHangupIncomingCall() {
  try {
    const TwilioModule = (await import("@/services/twilio/twilio")).default;
    await TwilioModule.hangup();
    emit("close-modal");
  } catch (error) {
    console.error("[CallInteractionPanel] Failed to hangup call:", error);
  }
}

function handleUseCueCardContent(payload: any) {
  if ((payload.channel === "call" || payload.channel === "voicemail") && payload.callSteps) {
    callScriptSteps.value = payload.callSteps;
    showCallScriptPanel.value = true;
  } else if (payload.channel === "call" && payload.content) {
    $toast.success("Call script generated — see cue card content");
  } else {
    emit("switch-channel", payload);
  }
}

async function fetchNumberDialingInfo() {
  try {
    const ContactNumberInfoService = require("@/services/contact/contact-number-info").default;
    const contactId = props.selectedBucket?.contactId || contact.value?.id;
    if (!contactId) return;
    const res = await ContactNumberInfoService.getForContact(String(contactId));
    const data = res?.data?.data || res?.data;
    numberDialingInfo.value = Array.isArray(data) ? data : [];
  } catch (e) {
    console.warn("Failed to fetch number dialing info", e);
  }
}

function setValues() {
  editBucketObj.value.id = props.selectedBucket.id;
  editBucketObj.value.taskType = props.selectedBucket.taskType;
  editBucketObj.value.followUpDate = props.selectedBucket.followUpDate;
  editBucketObj.value.bucketOptionId = props.selectedBucket.bucketOptionId;
}

function redirectToBuyPhoneNumber() {
  const buyNumberUrl = `/settings/call-phone-numbers/buy-number?owner=${account.value.id}`;
  router.push(buyNumberUrl);
  showBuyPhoneNumberModal.value = false;
}

const debouncedSearch = debounce(() => {
  if (!searchTerm.value || !searchTerm.value.trim()) {
    showSearchDropdown.value = false;
    return;
  }
  if (isPhoneInput.value) {
    searchTerm.value = new AsYouType().input(stripFormatting(searchTerm.value));
  }
  showSearchDropdown.value = true;
  getContacts();
}, 300);

function selectPhoneNumberToEdit(phoneNumberObj: any, anchorRect: DOMRect | null = null) {
  selectedContactNumber.value = phoneNumberObj;
  editModalAnchorRect.value = anchorRect;
  showEditPhoneNumberModal.value = true;
}

function handlePhoneDataChange(phoneObj: any, updatedData: any) {
  phoneObj.callType = updatedData.callType;
  phoneObj.valid = updatedData.validity === "Valid";
  phoneObj.ivrNumber = updatedData.ivrNumber;
  phoneObj.gateKeeperName = updatedData.gateKeeperName;
}

function selectContact(contactItem: any) {
  const firstPhone = contactItem.phones?.[0]?.number;
  const number = firstPhone || contactItem.mobileNumber || contactItem.directNumber;
  if (!number) {
    $toast.info("This contact has no phone number");
    return;
  }
  searchTerm.value = formatDisplayNumber(number);
  showSearchDropdown.value = false;
}

function selectContactPhone(contactItem: any, phone: any) {
  searchTerm.value = formatDisplayNumber(phone.number);
  showSearchDropdown.value = false;
}

async function toggleDialerDropdown() {
  showDialerDropdown.value = !showDialerDropdown.value;
  if (showDialerDropdown.value) {
    setTimeout(() => {
      document.addEventListener("mousedown", handleDialerClickOutside);
    }, 0);
  } else {
    document.removeEventListener("mousedown", handleDialerClickOutside);
  }
}

function handleDialerClickOutside(event: MouseEvent) {
  const dd = dialerDropdown.value;
  if (dd && !dd.contains(event.target as Node)) {
    showDialerDropdown.value = false;
    document.removeEventListener("mousedown", handleDialerClickOutside);
  }
}

function handleAddPhoneNumber(event: Event) {
  const target = event.currentTarget as HTMLElement;
  if (target) {
    addModalAnchorRect.value = target.getBoundingClientRect();
    showAddPhoneNumberModal.value = true;
  }
}

function startCallTimer() {
  callDuration.value = 0;
  if (callTimer.value) clearInterval(callTimer.value);
  callTimer.value = setInterval(() => {
    callDuration.value++;
  }, 1000);
}

function stopCallTimer() {
  if (callTimer.value) {
    clearInterval(callTimer.value);
    callTimer.value = null;
  }
}

async function toggleRecording() {
  if (!currentCall.value || !currentCallSid.value) {
    $toast.info("No ongoing call");
    return;
  }

  if (!account.value.allowCallRecording) {
    $toast.info("Please enable recording in settings.");
    return;
  }

  const wasRecording = saveRecording.value;
  saveRecording.value = !wasRecording; // optimistic
  const sid = parentCallSid.value || currentCallSid.value;
  try {
    if (wasRecording) {
      await Twilio.pauseRecording(sid);
      $toast.info("Recording paused");
    } else {
      await Twilio.resumeRecording(sid);
      $toast.info("Recording resumed");
    }
  } catch (err) {
    saveRecording.value = wasRecording; // rollback
    console.error("[CallInteractionPanel] toggleRecording failed:", err);
    $toast.error("Failed to update recording");
  }
}

async function selectMicrophone(deviceId: string) {
  try {
    await Twilio.setMicrophone(deviceId);
    selectedMicId.value = deviceId;
    $toast.info("Switched mic!");
  } catch (err) {
    console.error("[CallInteractionPanel] selectMicrophone failed:", err);
    $toast.error("Failed to switch microphone");
  }
  showMicrophoneDropdown.value = false;
}

function handleClickOutside(event: MouseEvent) {
  const dropdown = document.querySelector(".microphone-dropdown");
  if (dropdown && !dropdown.contains(event.target as Node) && showMicrophoneDropdown.value) {
    showMicrophoneDropdown.value = false;
  }
}

function registerCallActivityLog() {
  store
    .dispatch(REGISTER_ACTIVITY_LOG, {
      taskType: editBucketObj.value.taskType,
      contactId: contact.value?.id || props.selectedBucket.contactId,
      loggedOn: new Date(Date.now()),
      callSid: currentCallSid.value,
      organizationId: account.value.organizationId,
    })
    .then(() => {
      emit("refresh-buckets");
    });
}

async function startCall() {
  if (!hasPhoneNumbers.value) {
    $toast.error("No phone number available. Please purchase a phone number to make calls.");
    showBuyPhoneNumberModal.value = true;
    return;
  }

  if (!selectedNumber.value || !selectedNumberObj.value) {
    $toast.error("Please select a phone number to make calls.");
    return;
  }

  await showUsageBasedFeaturesModalOnce("call", async () => {
    await navigator.mediaDevices.getUserMedia({ audio: true });
    if (!to.value) {
      $toast.info("Please select a number.");
      return;
    }

    // Ensure Twilio device is initialized
    const deviceState = Twilio.getCallState();
    if (!deviceState.deviceReady) {
      if (isInitializingTwilio.value) {
        $toast.info("Call system is initializing, please wait...");
        return;
      }

      isInitializingTwilio.value = true;
      $toast.info("Initializing call system, please wait...");
      try {
        const identity = `user_${account.value.id}`;
        await Twilio.initTwilio(identity);
        $toast.success("Call system ready!");
      } catch (err) {
        console.error("Failed to initialize Twilio:", err);
        $toast.error("Failed to initialize call system. Please try again.");
        return;
      } finally {
        isInitializingTwilio.value = false;
      }
    }

    // Check if there's already an active call
    if (
      currentCall.value &&
      ["connecting", "ringing", "in-call", "reconnecting"].includes(status.value)
    ) {
      $toast.info("A call is already in progress. Please end the current call first.");
      return;
    }

    const twilioState = Twilio.getCallState();

    if (!currentCall.value && twilioState.hasActiveConnection) {
      // Reset Twilio state if UI indicates no call but Twilio does
      Twilio.resetCallState();
    }

    if (!account.value) {
      $toast.error("Account data not available. Please refresh and try again.");
      return;
    }

    status.value = "connecting";
    hasBaseCallLogCreated.value = false;
    hasCallBeenLogged.value = false;

    let call: any,
      callSid: string | null = null;
    try {
      const result = await Twilio.makeCall(
        to.value.replace(/\s+/g, ""),
        account.value.id,
        props.selectedBucket.contactId,
        props.selectedBucket.bucketOptionId,
        account.value.organizationId,
        enableTranscription.value,
        enableAISummary.value,
        "",
        pendingCallIcpId.value || ""
      );
      call = result.call;
      callSid = result.callSid ?? null;

      // Enable AI assistant if user chose "Call with AI"
      if (callSid && pendingCallWithAI.value) {
        enableAssistant(callSid, props.selectedBucket.contactId, callSid).catch((err) => {
          console.warn("[CallInteractionPanel] AI assistant enable failed:", err);
        });
      }
    } catch (error: any) {
      console.error("Error making call:", error);
      if (error?.message && error.message.includes("A call is already active")) {
        await Twilio.forceDisconnect();
        currentCall.value = null;
        currentCallSid.value = null;
        parentCallSid.value = null;
        status.value = "ready";

        try {
          const retryResult = await Twilio.makeCall(
            to.value.replace(/\s+/g, ""),
            account.value.id,
            props.selectedBucket.contactId,
            props.selectedBucket.bucketOptionId,
            account.value.organizationId,
            enableTranscription.value,
            enableAISummary.value,
            "",
            pendingCallIcpId.value || ""
          );
          call = retryResult.call;
          callSid = retryResult.callSid ?? null;
        } catch (retryError) {
          $toast.info("Unable to start call. Please try again.");
          status.value = "ready";
          return;
        }
      } else {
        const errorMessage = error?.message || error?.response?.data?.message || "";
        if (
          error?.response?.status === 400 &&
          (errorMessage.includes("No phone number found") ||
            errorMessage.includes("purchase a phone number"))
        ) {
          $toast.error("Please purchase a phone number to use this feature.");
          showBuyPhoneNumberModal.value = true;
          status.value = "ready";
          return;
        } else if (errorMessage.includes("No input devices available")) {
          $toast.error(
            "No microphone detected. Please check your microphone connection and browser permissions."
          );
          status.value = "error";
          return;
        } else if (errorMessage.includes("No output devices available")) {
          $toast.error("No speakers detected. Please check your audio output devices.");
          status.value = "error";
          return;
        } else {
          $toast.error(errorMessage || "Failed to make call. Please try again.");
          status.value = "error";
          return;
        }
      }
    }
    currentCall.value = markRaw(call);
    currentCallSid.value = callSid;
    if (callSid) setOutboundCallSid(callSid);

    call.on("ringing", () => {
      status.value = "ringing";
      createBaseCallLog();
    });

    call.on("accept", (conn: any) => {
      status.value = "in-call";
      currentCallSid.value = conn.parameters.CallSid;
      setOutboundCallSid(conn.parameters.CallSid);
      registerCallActivityLog();
      startCallTimer();

      // Enable AI assistant now that we have the confirmed SID
      if (pendingCallWithAI.value) {
        const confirmedSid = conn.parameters.CallSid;
        const contactId = contact.value?.id || props.selectedBucket?.contactId;
        if (confirmedSid && contactId) {
          enableAssistant(confirmedSid, String(contactId), confirmedSid).catch((err) => {
            console.warn("[CallInteractionPanel] AI assistant enable failed:", err);
          });
        }
        pendingCallWithAI.value = false;
      }
    });

    call.on("disconnect", () => {
      status.value = "ended";
      if (currentCallSid.value) startPostCallLock(currentCallSid.value);
      currentCall.value = null;
      isMuted.value = false;
      setTimeout(() => {
        parentCallSid.value = null;
        clearOutboundCallSid();
      }, 1000);
      $toast.info("Call Disconnected");
      stopCallTimer();
      mustLogAfterCall.value = true;
      disableAssistant();
    });

    call.on("reconnecting", () => {
      status.value = "reconnecting";
    });

    call.on("reconnected", () => {
      status.value = "in-call";
    });

    call.on("reject", () => {
      status.value = "ended";
      currentCall.value = null;
      currentCallSid.value = null;
      parentCallSid.value = null;
      clearOutboundCallSid();
      clearPostCallLock();
      isMuted.value = false;
      stopCallTimer();
      mustLogAfterCall.value = false;
      disableAssistant();
      $toast.info("Call Rejected");
    });

    call.on("cancel", () => {
      status.value = "ended";
      currentCall.value = null;
      currentCallSid.value = null;
      parentCallSid.value = null;
      clearOutboundCallSid();
      clearPostCallLock();
      stopCallTimer();
      mustLogAfterCall.value = false;
      pendingCallWithAI.value = false;
      disableAssistant();
      $toast.info("Call has been canceled");
    });

    call.on("error", () => {
      status.value = "error";
      currentCall.value = null;
      currentCallSid.value = null;
      parentCallSid.value = null;
      clearOutboundCallSid();
      clearPostCallLock();
      isMuted.value = false;
      stopCallTimer();
      mustLogAfterCall.value = false;
      pendingCallWithAI.value = false;
      disableAssistant();
    });
  }); // end showUsageBasedFeaturesModalOnce
}

async function addParticipant() {
  if (!searchTerm.value) {
    $toast.info("Please enter a phone number");
    return;
  }

  if (!currentCall.value || !currentCallSid.value) {
    $toast.info("No ongoing call to add participant to");
    return;
  }

  const res = await Twilio.addParticipant(stripFormatting(searchTerm.value), currentCallSid.value);
  if (res) {
    showDialerDropdown.value = false;
  }
}

function endCall() {
  try {
    Twilio.hangup();
    currentCall.value = null;
    status.value = "ended";
    isMuted.value = false;
    stopCallTimer();
    setTimeout(() => {
      parentCallSid.value = null;
      clearOutboundCallSid();
    }, 1000);
    mustLogAfterCall.value = true;
  } catch (error) {
    console.error("Error ending call:", error);
    if (currentCallSid.value) startPostCallLock(currentCallSid.value);
    currentCall.value = null;
    status.value = "ended";
    isMuted.value = false;
    stopCallTimer();
    parentCallSid.value = null;
    clearOutboundCallSid();
    mustLogAfterCall.value = true;
  }
}

function handlePhoneButtonClick(phoneNumber: string) {
  if (!hasPhoneNumbers.value) {
    $toast.error("No phone number available. Please purchase a phone number to make calls.");
    showBuyPhoneNumberModal.value = true;
    return;
  }

  const isActiveCallState = ["connecting", "ringing", "in-call", "reconnecting"].includes(
    status.value
  );
  const isCurrentCallNumber = to.value === phoneNumber;
  const hasActiveConnection = Twilio.getCallState().hasActiveConnection;

  if (
    (currentCall.value || hasActiveConnection || isActiveCallState) &&
    isCurrentCallNumber &&
    isActiveCallState
  ) {
    endCall();
  } else {
    // Has a known contact — show "Call with AI / Call without AI" choice
    const contactId = contact.value?.id || props.selectedBucket?.contactId;
    if (contactId) {
      pendingCallNumber.value = phoneNumber;
      showAIPrompt.value = true;
    } else {
      pendingCallIcpId.value = null;
      to.value = phoneNumber;
      startCall();
    }
  }
}

async function proceedWithAI(icpId?: string) {
  if (!pendingCallNumber.value) return;
  showAIPrompt.value = false;
  isPreparingAIContext.value = true;
  pendingCallWithAI.value = true;
  pendingCallIcpId.value = icpId || null;

  const contactId = contact.value?.id || props.selectedBucket?.contactId;
  to.value = pendingCallNumber.value;
  pendingCallNumber.value = null;

  try {
    await Promise.race([
      prepareContext(String(contactId), icpId),
      new Promise<void>((resolve) => setTimeout(resolve, 25_000)),
    ]);
  } catch (err) {
    console.warn("[CallInteractionPanel] Pre-call context prep failed, proceeding anyway:", err);
  } finally {
    isPreparingAIContext.value = false;
  }

  await startCall();
}

function proceedWithoutAI(icpId?: string) {
  if (!pendingCallNumber.value) return;
  showAIPrompt.value = false;
  pendingCallWithAI.value = false;
  pendingCallIcpId.value = icpId || null;
  to.value = pendingCallNumber.value;
  pendingCallNumber.value = null;
  startCall();
}

function handleCloseCallModal() {
  // If we are waiting for AI briefing, stop it
  if (isPreparingAIContext.value) {
    isPreparingAIContext.value = false;
  }

  // If a call is active or ringing, end it
  const activeCallStates = ["connecting", "ringing", "in-call", "reconnecting"];
  if (activeCallStates.includes(status.value) || !!props.incomingCallData) {
    endCall();
    if (props.incomingCallData) {
      handleHangupIncomingCall();
    }
  }

  showAIPrompt.value = false;
  pendingCallNumber.value = null;
}

function toggleMuteCall() {
  if (!currentCall.value) {
    $toast.info("No ongoing call");
    return;
  }

  if (isMuted.value) {
    Twilio.unmuteCall();
    isMuted.value = false;
  } else {
    Twilio.muteCall();
    isMuted.value = true;
  }
}

async function handleTransfer(phoneNumber: string) {
  if (!currentCall.value || !currentCallSid.value) {
    $toast.info("No ongoing call to transfer");
    return;
  }

  const sid = parentCallSid.value || currentCallSid.value;
  try {
    await Twilio.transferCall(sid, phoneNumber);
    $toast.success("Transfer initiated");
    isTransferringCall.value = false;
    // Agent's leg drops once the child is redirected; tear down local UI state.
    endCall();
  } catch (error) {
    console.error("Transfer failed:", error);
    $toast.error("Unable to transfer call");
  }
}

function transferCall() {
  if (!searchTerm.value) {
    $toast.info("Please enter a phone number to transfer to");
    return;
  }
  handleTransfer(stripFormatting(searchTerm.value));
}

async function selectSpeaker(deviceId: string) {
  try {
    await Twilio.setSpeaker(deviceId);
    selectedSpeakerId.value = deviceId;
    $toast.info("Switched speaker");
  } catch (err) {
    console.error("[CallInteractionPanel] selectSpeaker failed:", err);
    $toast.error("Failed to switch speaker");
  }
}

async function createBaseCallLog() {
  try {
    if (!currentCallSid.value || hasBaseCallLogCreated.value) {
      return;
    }

    const maxRetries = 5;
    const retryDelay = 500;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      if (attempt > 1) {
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }

      const direction = "outbound";
      const payload = {
        callSid: currentCallSid.value,
        from: selectedNumber.value,
        to: (to.value || "").replace(/\s+/g, ""),
        direction,
        status: "completed",
        duration: callDuration.value || 0,
        contactId: props.selectedBucket?.contactId,
        userId: account.value?.id,
        organizationId: account.value?.organizationId,
        saveRecording: !!saveRecording.value,
      };

      try {
        const callLogResponse = await registerCallLog(payload as any);

        if (callLogResponse) {
          const backendParentCallSid = callLogResponse.parentCallSid || callLogResponse.callSid;

          if (backendParentCallSid && backendParentCallSid !== currentCallSid.value) {
            parentCallSid.value = backendParentCallSid;
            setOutboundCallSid(backendParentCallSid);
            hasBaseCallLogCreated.value = true;
            return;
          } else if (backendParentCallSid === currentCallSid.value) {
            // Same call sid — continue retrying
          } else {
            break;
          }
        }
      } catch (e) {
        console.error("Failed to create base call log:", e);
      }
    }

    hasBaseCallLogCreated.value = true;
  } catch (e) {
    console.warn("Failed to create base call log:", e);
    hasBaseCallLogCreated.value = true;
  }
}

function refreshContact() {
  getContact();
  emit("refresh-buckets");
}

function onPhoneNumberChange(phoneNumber: PhoneNumberDto | null) {
  selectedNumberObj.value = phoneNumber;
  selectedNumber.value = phoneNumber?.number || null;
}

const HEALTH_STATUS_COLORS: Record<string, string> = {
  green: "#22c55e",
  yellow: "#f59e0b",
  red: "#ef4444",
  unknown: "#9ca3af",
};

const HEALTH_STATUS_LABELS: Record<string, string> = {
  green: "Healthy",
  yellow: "Needs attention",
  red: "Poor health",
  unknown: "Unknown",
};

// Used both as the badge's native title (formatter output is v-html, so a real
// v-tooltip directive can't attach there) and as the Select option's `description`,
// which renders the same styled hover popup used on the Phone Numbers settings table.
function formatHealthTooltip(option: PhoneNumberDto): string {
  const status = option.healthStatus || "unknown";
  const label = HEALTH_STATUS_LABELS[status] || "Unknown";

  if (status === "unknown" || option.answerRate == null) {
    return `${label} — not enough recent call volume to measure`;
  }

  const answerRate = Number(option.answerRate).toFixed(1);
  const blockedRate = Number(option.blockedCallRate ?? 0).toFixed(1);
  const shortRate = Number(option.shortCallRate ?? 0).toFixed(1);
  return `${label} — Answer rate: ${answerRate}% · Blocked: ${blockedRate}% · Short calls: ${shortRate}%`;
}

function formatPhoneNumberWithCountry(option: PhoneNumberDto) {
  if (!option || !option.number) return option?.number || "";

  const healthStatus = option.healthStatus || "unknown";
  const healthColor = HEALTH_STATUS_COLORS[healthStatus] || HEALTH_STATUS_COLORS.unknown;
  const healthLabel = HEALTH_STATUS_LABELS[healthStatus] || "Unknown";

  const healthBadgeStyle = `display: inline-flex; align-items: center; font-size: 10px; font-weight: 600; color: ${healthColor}; background: ${healthColor}1a; padding: 2px 8px; border-radius: 8px; white-space: nowrap; flex-shrink: 0; margin-left: auto;`;
  const healthBadgeText =
    option.answerRate != null
      ? `${healthLabel} · ${Number(option.answerRate).toFixed(0)}%`
      : healthLabel;
  const healthBadgeHtml = `<span style="${healthBadgeStyle}">${healthBadgeText}</span>`;

  try {
    const phoneNumber = parsePhoneNumberFromString(option.number);
    if (phoneNumber && phoneNumber.isValid()) {
      const formattedNumber = phoneNumber.formatInternational();

      let locationText = "";
      if (option.city || option.region || option.countryCode) {
        locationText = formatLocation(option.city, option.region, option.countryCode);
      } else {
        const countryCode = phoneNumber.country;
        if (countryCode) {
          locationText = formatLocation(null, null, countryCode);
        }
      }

      const phoneNumberStyle =
        "font-weight: 500; color: #1f2937; flex-shrink: 0; white-space: nowrap; font-size: 14px;";
      const locationStyle =
        "display: inline-flex; align-items: center; gap: 4px; color: #6b7280; font-size: 11px; font-weight: 400; white-space: nowrap; flex-shrink: 0; margin-left: 10px; padding: 2px 8px; background: #f3f4f6; border-radius: 12px;";
      const iconStyle = "font-size: 12px; color: #9ca3af; flex-shrink: 0;";
      const containerStyle =
        "display: flex; align-items: center; width: 100%; gap: 8px; flex-wrap: nowrap; min-width: 0;";

      return `
        <span style="${containerStyle}">
          <span style="${phoneNumberStyle}">${formattedNumber}</span>
          ${
            locationText
              ? `
            <span style="${locationStyle}">
              <svg style="${iconStyle}" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              ${locationText}
            </span>
          `
              : ""
          }
          ${healthBadgeHtml}
        </span>
      `.trim();
    }
  } catch (error) {
    console.warn("Error parsing phone number:", error);
  }

  return `
    <span style="display: flex; align-items: center; width: 100%; gap: 8px;">
      <span>${option.number}</span>
      ${healthBadgeHtml}
    </span>
  `.trim();
}

function refreshContactData() {
  emit("refresh-buckets");
}

function toggleDeleteContactPhoneNumber(phoneNumber: any) {
  selectedContactNumber.value = phoneNumber;
  showDeleteConfirmationModal.value = true;
}

function deleteContactPhoneNumber() {
  if (!selectedContactNumber.value) return Promise.resolve();
  return deletePhoneMutation({
    id: contact.value?.id || props.selectedBucket.contactId,
    phoneNumber: selectedContactNumber.value.number,
  }).then((res: any) => {
    selectedContactNumber.value = null;
    return res;
  });
}

function shouldUpdateParentCallSid(newParentCallSid: string, data: any) {
  if (!parentCallSid.value) return true;
  if (newParentCallSid === parentCallSid.value) return false;
  if (data.callSid && data.callSid === currentCallSid.value) return true;
  return false;
}

function setupSocketListeners() {
  try {
    socket.value = getSocket();

    socket.value.on("call:start", (data: any) => {
      const pCallSid = data.parentCallSid || data.callSid;
      if (pCallSid) {
        if (!parentCallSid.value || shouldUpdateParentCallSid(pCallSid, data)) {
          parentCallSid.value = pCallSid;
          setOutboundCallSid(pCallSid);
        }
      }
    });

    socket.value.on("call:status", (data: any) => {
      const pCallSid = data.parentCallSid || data.callSid;
      if (pCallSid && data.status === "ringing") {
        if (!parentCallSid.value || shouldUpdateParentCallSid(pCallSid, data)) {
          parentCallSid.value = pCallSid;
          setOutboundCallSid(pCallSid);
        }
      }
    });

    socket.value.on("call:ringing", (data: any) => {
      const pCallSid = data.parentCallSid || data.callSid;
      if (pCallSid) {
        if (!parentCallSid.value || shouldUpdateParentCallSid(pCallSid, data)) {
          parentCallSid.value = pCallSid;
          setOutboundCallSid(pCallSid);
        }
      }
    });
  } catch (error) {
    console.error("Error setting up socket listeners:", error);
  }
}

function cleanupSocketListeners() {
  if (socket.value) {
    socket.value.off("call:start");
    socket.value.off("call:status");
    socket.value.off("call:ringing");
    socket.value = null;
  }
}

async function loadMicrophones() {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    microphones.value = devices
      .filter((device) => device.kind === "audioinput")
      .map((device) => ({
        deviceId: device.deviceId,
        label: device.label || `Microphone ${device.deviceId.slice(0, 8)}`,
      }));
    if (microphones.value.length && !selectedMicId.value) {
      selectedMicId.value = microphones.value[0].deviceId;
    }
  } catch (error) {
    console.error("Error loading microphones:", error);
    microphones.value = [];
  }

  try {
    speakers.value = Twilio.getSpeakers();
    if (speakers.value.length && !selectedSpeakerId.value) {
      selectedSpeakerId.value = speakers.value[0].deviceId;
    }
  } catch (err) {
    console.warn("[CallInteractionPanel] Failed to enumerate speakers:", err);
    speakers.value = [];
  }
}

// --- Watchers ---

function handleIVRClickOutside(event: MouseEvent) {
  const el = ivrPopover.value;
  if (!el) return;
  const target = event.target as Node;
  const toggleBtn = el.parentElement?.querySelector(".action-icon");
  if (toggleBtn?.contains(target)) return;
  if (!el.contains(target)) {
    showIVRDropdown.value = false;
  }
}

watch(showIVRDropdown, (val) => {
  if (val) {
    setTimeout(() => document.addEventListener("mousedown", handleIVRClickOutside), 0);
  } else {
    document.removeEventListener("mousedown", handleIVRClickOutside);
  }
});

watch(showMicrophoneDropdown, (val) => {
  if (val) {
    document.addEventListener("mousedown", handleClickOutside);
  } else {
    document.removeEventListener("mousedown", handleClickOutside);
  }
});

watch(
  () => props.pendingCueCardContent,
  (payload) => {
    if (payload && payload.channel === "call" && payload.callSteps) {
      callScriptSteps.value = payload.callSteps;
      showCallScriptPanel.value = true;
      emit("content-applied");
    }
  }
);

watch(
  () => props.selectedBucket,
  (newBucket) => {
    setValues();
    fetchNumberDialingInfo();
    if (newBucket?.contact?.id) {
      getContact();
    }
  },
  { immediate: true }
);

watch(isDispositionPending, (pending, wasPending) => {
  if (wasPending && !pending && mustLogAfterCall.value) {
    mustLogAfterCall.value = false;
    currentCallSid.value = null;
    hasCallBeenLogged.value = true;
    disableBeforeUnload();
  }
});

// Auto-select first phone number when data loads
watch(
  phoneNumbers,
  (nums) => {
    if (nums.length > 0 && !selectedNumberObj.value) {
      selectedNumberObj.value = nums[0];
      selectedNumber.value = nums[0].number;
    }
  },
  { immediate: true }
);

// --- Lifecycle ---

onMounted(() => {
  setupSocketListeners();
  setValues();
  loadMicrophones();
  if (contact.value?.id) {
    getContact();
  }
  fetchNumberDialingInfo();
});

onBeforeUnmount(() => {
  disableBeforeUnload();
  cleanupSocketListeners();
  stopCallTimer();
  if (showMicrophoneDropdown.value) {
    document.removeEventListener("mousedown", handleClickOutside);
  }
  if (showDialerDropdown.value) {
    document.removeEventListener("mousedown", handleDialerClickOutside);
  }
  if (showIVRDropdown.value) {
    document.removeEventListener("mousedown", handleIVRClickOutside);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (showAddPhoneNumberModal.value == true)
        ? (_openBlock(), _createBlock(AddPhoneNumberModal, {
            key: 0,
            contactId: __props.selectedBucket.contactId,
            anchorRect: addModalAnchorRect.value,
            onCloseAddPhoneNumberModal: _cache[0] || (_cache[0] = ($event: any) => (showAddPhoneNumberModal.value = false)),
            onRefreshContact: refreshContact
          }, null, 8, ["contactId", "anchorRect"]))
        : _createCommentVNode("", true),
      (showEditPhoneNumberModal.value == true)
        ? (_openBlock(), _createBlock(EditPhoneNumberModal, {
            key: 1,
            contactId: __props.selectedBucket.contactId,
            selectedNumber: selectedContactNumber.value,
            anchorRect: editModalAnchorRect.value,
            onCloseEditPhoneNumberModal: _cache[1] || (_cache[1] = ($event: any) => (showEditPhoneNumberModal.value = false)),
            onRefreshContact: refreshContact
          }, null, 8, ["contactId", "selectedNumber", "anchorRect"]))
        : _createCommentVNode("", true),
      (showDialerDropdown.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "dialer-dropdown",
            ref_key: "dialerDropdown",
            ref: dialerDropdown,
            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
            onMousedown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                (isTransferringCall.value)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_4, "Transfer Call"))
                  : (_openBlock(), _createElementBlock("strong", _hoisted_5, "Add A Conference Call")),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_unref(Icon), {
                      icon: "mdi:account-outline",
                      width: "16",
                      height: "16",
                      style: {"color":"#6b7280"}
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchTerm).value = $event)),
                      onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(debouncedSearch) && _unref(debouncedSearch)(...args))),
                      type: "text",
                      class: "form-control border-0 custom-dialer-input",
                      placeholder: "Search user or enter a number",
                      style: {"padding":"0px"},
                      autocomplete: "off"
                    }, null, 544), [
                      [_vModelText, searchTerm.value]
                    ])
                  ]),
                  (searchTerm.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "dialer-backspace-btn",
                        onClick: handleDialerBackspace,
                        "aria-label": "Backspace"
                      }, [
                        _createVNode(_unref(Icon), {
                          icon: "mdi:backspace",
                          width: "14",
                          height: "14"
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_unref(Icon), {
                      icon: "mdi:magnify",
                      width: "12",
                      height: "12",
                      style: {"color":"#6b7280"}
                    })
                  ])
                ]),
                (contacts.value && contacts.value.length && searchTerm.value && showSearchDropdown.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contacts.value, (c) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: c.id,
                            class: "contact-item"
                          }, [
                            _createElementVNode("div", {
                              class: "contact-info",
                              onClick: ($event: any) => (selectContact(c))
                            }, [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(capitalize(c.fname)) + " " + _toDisplayString(capitalize(c.lname)), 1),
                              (c.company?.name)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(c.company.name), 1))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_11),
                            (c.phones && c.phones.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.phones, (phone, idx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: idx,
                                      class: "contact-phone-row",
                                      onClick: ($event: any) => (selectContactPhone(c, phone))
                                    }, [
                                      _createElementVNode("span", _hoisted_16, _toDisplayString(phone.type || "PHONE"), 1),
                                      _createElementVNode("span", _hoisted_17, _toDisplayString(formatDisplayNumber(phone.number)), 1)
                                    ], 8, _hoisted_15))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_18, "No phone"))
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("div", _hoisted_20, null, 512), [
                    [_vShow, contactsIsLoading.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dialPadButtons, (button) => {
                    return _createElementVNode("button", _mergeProps({
                      key: button.value,
                      class: ["btn btn-light dialer-btn", button.specialClass]
                    }, _toHandlers(button.events, true)), _toDisplayString(button.value), 17)
                  }), 64))
                ]),
                (isTransferringCall.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (transferCall())),
                      class: "call-btn-popup"
                    }, [
                      _createVNode(_unref(Icon), {
                        icon: "mdi:phone",
                        width: "18",
                        height: "18",
                        style: {"color":"#ffffff"}
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 4,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (addParticipant())),
                      class: "call-btn-popup"
                    }, [
                      _createVNode(_unref(Icon), {
                        icon: "mdi:phone",
                        width: "18",
                        height: "18",
                        style: {"color":"#ffffff"}
                      })
                    ]))
              ])
            ])
          ], 544))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_22, [
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-6" }, [
          _createElementVNode("h6", { class: "phone-numbers-title" }, "Phone Numbers")
        ], -1)),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-new-field",
              style: {"flex-shrink":"0"},
              onClick: handleAddPhoneNumber
            }, [
              _createVNode(_unref(Icon), {
                icon: "tabler:plus",
                class: "add-field-icon"
              }),
              _cache[17] || (_cache[17] = _createTextVNode(" Add Number ", -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(OutreachCueCards, {
            "icp-options": icpOptions.value,
            "icp-loading": props.icpLoading,
            "contact-id": __props.selectedBucket?.contact?.id || '',
            "contact-name": 
              [__props.selectedBucket?.contact?.fname, __props.selectedBucket?.contact?.lname]
                .filter(Boolean)
                .join(' ')
            ,
            "full-width": true,
            onUseContent: handleUseCueCardContent
          }, null, 8, ["icp-options", "icp-loading", "contact-id", "contact-name"])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validContactNumbers.value, (phoneObj, index) => {
          return (_openBlock(), _createBlock(CallInfoRow, {
            key: `${phoneObj.number}-${index}`,
            "phone-number": formatPhoneNumber(phoneObj.number),
            "contact-id": contact.value?.id,
            "call-type": phoneObj.callType || phoneObj.type || 'Mobile',
            validity: 
            phoneObj.isValidLead === true
              ? 'Valid'
              : phoneObj.isValidLead === false
                ? 'Invalid'
                : 'Unverified'
          ,
            "ivr-number": phoneObj.ivrNumbers ? phoneObj.ivrNumbers.join('-') : '',
            "gate-keeper-name": phoneObj.gateKeeperName || '',
            "call-status": status.value,
            "is-current-call": to.value === phoneObj.number,
            "call-sid": phoneObj.callSid || currentCallSid.value,
            onChange: ($event: any) => (handlePhoneDataChange(phoneObj, $event)),
            onDataUpdated: refreshContactData,
            onPhoneClick: ($event: any) => (handlePhoneButtonClick(phoneObj.number)),
            onEditClick: (num, rect) => selectPhoneNumberToEdit(phoneObj, rect),
            onDeleteClick: ($event: any) => (toggleDeleteContactPhoneNumber(phoneObj))
          }, null, 8, ["phone-number", "contact-id", "call-type", "validity", "ivr-number", "gate-keeper-name", "call-status", "is-current-call", "call-sid", "onChange", "onPhoneClick", "onEditClick", "onDeleteClick"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-new-field",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (toggleDialerDropdown()))
          }, [
            _createVNode(_unref(Icon), {
              icon: "tabler:plus",
              class: "add-field-icon"
            }),
            _cache[19] || (_cache[19] = _createTextVNode(" Add Call ", -1))
          ])
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-6" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _cache[22] || (_cache[22] = _createElementVNode("h6", { style: {"font-size":"12px","color":"#646464","margin-bottom":"0"} }, "Calling from", -1)),
            _createElementVNode("span", _hoisted_33, [
              _createVNode(_unref(Icon), {
                icon: "mdi:information-outline",
                style: {"font-size":"12px","flex-shrink":"0"}
              }),
              _cache[21] || (_cache[21] = _createTextVNode(" Your plan includes up to 5 phone numbers for free. ", -1))
            ])
          ])
        ])
      ]),
      (!hasPhoneNumbers.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_unref(Icon), {
                  icon: "mdi:information-outline",
                  class: "banner-info-icon"
                }),
                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "banner-text" }, "No phone number available.", -1)),
                _createElementVNode("button", {
                  class: "banner-link-button",
                  onClick: redirectToBuyPhoneNumber
                }, [
                  _cache[23] || (_cache[23] = _createTextVNode(" Add phone number ", -1)),
                  _createVNode(_unref(Icon), {
                    icon: "mdi:arrow-right",
                    class: "banner-arrow-icon"
                  })
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_unref(Select), {
                  modelValue: selectedNumberObj.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedNumberObj).value = $event)),
                  options: phoneNumbers.value,
                  placeholder: "Select a phone number",
                  "label-key": "number",
                  "value-key": "number",
                  "show-actions": false,
                  "show-add-button": false,
                  formatter: formatPhoneNumberWithCountry,
                  "return-object": true,
                  "info-tooltip-trigger": "hover",
                  onChange: onPhoneNumberChange
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm add-option-btn-side",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (showBuyPhoneNumberModal.value = true))
                }, [
                  _createVNode(_unref(Icon), {
                    icon: "mynaui:plus-solid",
                    style: {"font-size":"16px"}
                  })
                ]),
                (showBuyPhoneNumberModal.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createVNode(_unref(Icon), {
                              icon: "mdi:phone-plus",
                              style: {"font-size":"16px","color":"#3e3efe","font-weight":"bold"}
                            })
                          ]),
                          _cache[25] || (_cache[25] = _createElementVNode("span", {
                            class: "card-title",
                            style: {"font-weight":"bold"}
                          }, "Buy Phone Number", -1))
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-close-card",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (showBuyPhoneNumberModal.value = false))
                        }, [
                          _createVNode(_unref(Icon), {
                            icon: "mdi:close",
                            style: {"font-size":"14px"}
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _cache[27] || (_cache[27] = _createElementVNode("p", { class: "card-text" }, "Purchase an additional phone number for your organization.", -1)),
                        _createVNode(_unref(Button), {
                          variant: "primary",
                          size: "md",
                          icon: "mdi:phone-plus",
                          "icon-position": "left",
                          onClick: redirectToBuyPhoneNumber,
                          block: ""
                        }, {
                          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                            _createTextVNode(" Buy Phone Number ", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _cache[29] || (_cache[29] = _createElementVNode("h6", { style: {"font-size":"12px","color":"#646464","margin-bottom":"8px"} }, "Call Disposition", -1)),
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_unref(Icon), {
              icon: "mdi:phone-check-outline",
              width: "16",
              height: "16",
              class: "disposition-readonly__icon"
            }),
            _createElementVNode("span", _hoisted_49, _toDisplayString(latestCallDispositionName.value || "No disposition set"), 1),
            _createElementVNode("button", {
              type: "button",
              class: "disposition-readonly__hint",
              disabled: !callHistoryContactId.value,
              onClick: _cache[12] || (_cache[12] = ($event: any) => (showLastInteractionModal.value = true))
            }, [
              _createVNode(_unref(Icon), {
                icon: "mdi:pencil-outline",
                width: "13",
                height: "13"
              }),
              _cache[28] || (_cache[28] = _createTextVNode(" Call History ", -1))
            ], 8, _hoisted_50)
          ])
        ])
      ])
    ]),
    _createVNode(CallSessionModal, {
      icps: __props.icps,
      show: 
        showAIPrompt.value ||
        isPreparingAIContext.value ||
        activeCallStates.value.includes(status.value) ||
        !!__props.incomingCallData
      ,
      contactName: 
        (capitalize(contact.value?.fname) + ' ' + capitalize(contact.value?.lname)).trim() || undefined
      ,
      to: to.value,
      status: status.value,
      isPreparingAIContext: isPreparingAIContext.value,
      showAIPrompt: showAIPrompt.value,
      incomingCallData: __props.incomingCallData,
      formattedIncomingCallTimer: formattedIncomingCallTimer.value,
      formattedCallTimer: formattedCallTimer.value,
      isMuted: isMuted.value,
      saveRecording: saveRecording.value,
      enableTranscription: enableTranscription.value,
      parentCallSid: parentCallSid.value,
      currentCallSid: currentCallSid.value,
      account: account.value,
      microphones: microphones.value,
      speakers: speakers.value,
      selectedMicId: selectedMicId.value,
      selectedSpeakerId: selectedSpeakerId.value,
      isThinking: _unref(isThinking),
      isStreaming: _unref(isStreaming),
      hasSuggestions: _unref(hasSuggestions),
      currentStreamingText: _unref(currentStreamingText),
      latestSuggestion: _unref(latestSuggestion),
      aiSuggestions: _unref(suggestions),
      briefing: null,
      onClose: handleCloseCallModal,
      onProceedWithAi: proceedWithAI,
      onProceedWithoutAi: proceedWithoutAI,
      onAnswerIncomingCall: handleAnswerIncomingCall,
      onDeclineIncomingCall: handleDeclineIncomingCall,
      onHangupIncomingCall: handleHangupIncomingCall,
      onHangup: endCall,
      onToggleRecord: toggleRecording,
      onToggleMute: toggleMuteCall,
      onTransferCall: handleTransfer,
      onSelectMicrophone: selectMicrophone,
      onSelectSpeaker: selectSpeaker,
      onSendDigit: appendToIVRInputValue
    }, null, 8, ["icps", "show", "contactName", "to", "status", "isPreparingAIContext", "showAIPrompt", "incomingCallData", "formattedIncomingCallTimer", "formattedCallTimer", "isMuted", "saveRecording", "enableTranscription", "parentCallSid", "currentCallSid", "account", "microphones", "speakers", "selectedMicId", "selectedSpeakerId", "isThinking", "isStreaming", "hasSuggestions", "currentStreamingText", "latestSuggestion", "aiSuggestions"]),
    (showDeleteConfirmationModal.value == true)
      ? (_openBlock(), _createBlock(DeletePhoneNumberModal, {
          key: 0,
          deleteFunction: deleteContactPhoneNumber,
          onClose: _cache[13] || (_cache[13] = ($event: any) => (showDeleteConfirmationModal.value = false)),
          onRefresh: _cache[14] || (_cache[14] = ($event: any) => (getContact()))
        }))
      : _createCommentVNode("", true),
    _createVNode(DraggableCallScript, {
      "call-steps": callScriptSteps.value,
      visible: showCallScriptPanel.value,
      onClose: _cache[15] || (_cache[15] = ($event: any) => (showCallScriptPanel.value = false))
    }, null, 8, ["call-steps", "visible"]),
    (showLastInteractionModal.value && callHistoryContactId.value)
      ? (_openBlock(), _createBlock(LastInteractionModal, {
          contactId: callHistoryContactId.value,
          "contact-email": contact.value?.email || '',
          "initial-channel": _unref(TaskType).call,
          key: callHistoryContactId.value,
          onCloseLastInteractionModal: _cache[16] || (_cache[16] = ($event: any) => (showLastInteractionModal.value = false))
        }, null, 8, ["contactId", "contact-email", "initial-channel"]))
      : _createCommentVNode("", true)
  ]))
}
}

})